import React from 'react';
import { Link } from 'react-router-dom';
import './Vilkår.css';

const Vilkår = () => {
  return (
    <div className="vilkår-page">
      <div className="vilkår-container">
        <div className="vilkår-header">
          <Link to="/" className="back-link">
            <span className="arrow">←</span> Tilbake
          </Link>
          <h1>Vilkår for bruk av appen</h1>
        </div>

        <div className="vilkår-content">
          <section className="vilkår-section">
            <h2>1. INTRODUKSJON</h2>
            <p>
              Ved å laste ned, installere, få tilgang til eller bruke Appen, samtykker du til å være bundet av disse Vilkårene. 
              Hvis du ikke samtykker til disse Vilkårene, må du ikke laste ned, installere, få tilgang til eller bruke Appen.
            </p>
          </section>

          <section className="vilkår-section">
            <h2>2. ABONNEMENT OG BETALING</h2>
            
            <h3>2.1 Abonnementsplaner</h3>
            <p>
              Appen tilbyr ulike abonnementsplaner, inkludert månedlige, halvårlige og årlige abonnementer. 
              Priser for hver plan vil være tydelig angitt i Appen og websiden før kjøp.
            </p>

            <h3>2.2 Betalingsbetingelser</h3>
            <ul>
              <li>For månedlige abonnementer belastes betalingen månedlig.</li>
              <li>For halvårs- og helårsabonnementer belastes hele summen ved oppstart av abonnementsperioden.</li>
              <li>Alle priser er inkludert merverdiavgift (MVA) der det er aktuelt.</li>
            </ul>

            <h3>2.3 Automatisk fornyelse</h3>
            <p>Alle abonnementer fornyes automatisk inntil abonnementet sies opp. Dette betyr at:</p>
            <ul>
              <li>Månedlige abonnementer fornyes hver måned.</li>
              <li>Halvårsabonnementer fornyes hver sjette måned.</li>
              <li>Helårsabonnementer fornyes hvert år.</li>
            </ul>

            <h3>2.4 Varsel om fornyelse</h3>
            <p>
              For halvårs- og helårsabonnementer vil vi sende deg en påminnelse via e-post før abonnementet fornyes. 
              Denne påminnelsen sendes normalt 14 dager før fornyelse.
            </p>

            <h3>2.5 Oppsigelse av abonnement</h3>
            <p>Du kan når som helst avslutte ditt abonnement. Oppsigelse må gjøres:</p>
            <ul>
              <li>På vår webside: <a href="https://www.lopeglad.no" target="_blank" rel="noopener noreferrer">www.lopeglad.no</a></li>
            </ul>
            <p>
              En oppsigelse trer i kraft ved slutten av gjeldende faktureringsperiode. 
              Du vil fortsatt ha tilgang til de betalte funksjonene frem til denne datoen.
            </p>

            <h3>2.6 Angrefrist</h3>
            <p>
              Du har rett til å benytte 14 dagers angrefrist fra den dagen du tegnet abonnementet. 
              Hvis du ønsker å benytte angrefristen, må du gi oss beskjed innen denne perioden via e-post til 
              <a href="mailto:support@lopeglad.no">support@lopeglad.no</a> eller gjennom Appens kundeservicefunksjon. 
              Ved gyldig bruk av angrefristen vil vi refundere alle betalinger vi har mottatt fra deg minus admin gebyr til Stripe, 
              uten unødig opphold og senest 14 dager fra den dagen vi mottok din melding om at du ønsker å benytte angrefristen.
            </p>

            <h3>2.7 Refusjonspolitikk</h3>
            <p>Utover den lovbestemte angrefristen gjelder følgende refusjonspolitikk:</p>
            <ul>
              <li>
                For halvårs- og helårsabonnementer er betalingen bindende for hele perioden og refunderes ikke ved oppsigelse 
                før perioden utløper, med mindre annet følger av ufravikelig lovgivning.
              </li>
              <li>
                Refusjoner kan vurderes i tilfeller der tjenesten har betydelige tekniske feil som hindrer bruk over lengre tid.
              </li>
            </ul>
          </section>

          <section className="vilkår-section">
            <h2>3. BRUK AV APPEN</h2>
            
            <h3>3.1 Lisens til bruk</h3>
            <p>
              Vi gir deg en begrenset, ikke-eksklusiv, ikke-overførbar, gjenkallelig lisens til å bruke Appen til personlige, 
              ikke-kommersielle formål.
            </p>

            <h3>3.2 Begrensninger</h3>
            <p>Du samtykker til ikke å:</p>
            <ul>
              <li>Kopiere, modifisere eller skape avledede verk basert på Appen.</li>
              <li>Forsøke å utvinne kildekoden til Appen.</li>
              <li>Fjerne opphavsretts- eller andre eiendomsmerker fra Appen.</li>
              <li>Bruke Appen til ulovlige eller uautoriserte formål.</li>
              <li>Overføre virus eller annen skadelig kode til Appen.</li>
              <li>Selge, leie ut eller underlisensiere tilgangen til Appen.</li>
            </ul>

            <h3>3.3 Treningsdata og personlige resultater</h3>
            <p>
              Data som registreres gjennom din bruk av Appen (som løperuter, treningsresultater og personlig fremgang) tilhører deg, 
              men du gir oss en lisens til å bruke denne informasjonen i anonymisert og aggregert form for å forbedre våre tjenester.
            </p>
          </section>

          <section className="vilkår-section">
            <h2>4. PERSONVERN OG DATABEHANDLING</h2>
            
            <h3>4.1 Personvernpolitikk</h3>
            <p>
              Vår behandling av personopplysninger er beskrevet i vår Personvernpolitikk, som er en integrert del av disse Vilkårene.
            </p>

            <h3>4.2 Datalagring</h3>
            <p>
              Vi lagrer dine personopplysninger så lenge det er nødvendig for å levere tjenestene eller så lenge det er påkrevd 
              etter gjeldende lovgivning.
            </p>
          </section>

          <section className="vilkår-section">
            <h2>5. ENDRINGER I TJENESTEN OG VILKÅRENE</h2>
            
            <h3>5.1 Endringer i Tjenesten</h3>
            <p>
              Vi forbeholder oss retten til å modifisere, suspendere eller avbryte Appen eller deler av den når som helst, 
              med eller uten varsel.
            </p>

            <h3>5.2 Endringer i Vilkårene</h3>
            <p>
              Vi kan oppdatere disse Vilkårene fra tid til annen. Ved vesentlige endringer vil vi gi deg beskjed via e-post 
              eller gjennom en melding i Appen. Din fortsatte bruk av Appen etter at endringene trer i kraft, utgjør ditt 
              samtykke til de reviderte Vilkårene.
            </p>
          </section>

          <section className="vilkår-section">
            <h2>6. ANSVARSFRASKRIVELSE OG BEGRENSNING AV ANSVAR</h2>
            
            <h3>6.1 Ansvarsfraskrivelse</h3>
            <p>
              Appen leveres «som den er» og «som tilgjengelig» uten noen form for garanti, verken uttrykt eller underforstått.
            </p>

            <h3>6.2 Treningsråd</h3>
            <p>
              Treningsråd og -programmer som tilbys gjennom Appen er generelle anbefalinger og erstatter ikke profesjonell 
              medisinsk rådgivning. Konsulter alltid lege før du starter et nytt treningsprogram, spesielt hvis du har 
              eksisterende helseproblemer.
            </p>

            <h3>6.3 Begrensning av ansvar</h3>
            <p>
              I den grad det er tillatt etter gjeldende lov, skal vi ikke være ansvarlige for indirekte, tilfeldige, spesielle 
              eller følgeskader som oppstår fra eller i forbindelse med din bruk av Appen.
            </p>
          </section>

          <section className="vilkår-section">
            <h2>7. OPPHØR</h2>
            
            <h3>7.1 Opphør fra din side</h3>
            <p>
              Du kan slutte å bruke Appen når som helst og kan avslutte disse Vilkårene ved å slette Appen og alle kopier av den 
              fra dine enheter.
            </p>

            <h3>7.2 Opphør fra vår side</h3>
            <p>
              Vi kan suspendere eller avslutte din tilgang til Appen umiddelbart, uten forhåndsvarsel eller ansvar, hvis du bryter 
              disse Vilkårene.
            </p>
          </section>

          <section className="vilkår-section">
            <h2>8. GENERELLE BESTEMMELSER</h2>
            
            <h3>8.1 Gjeldende lov</h3>
            <p>
              Disse Vilkårene skal være underlagt og tolkes i samsvar med norsk lov, uten hensyn til lovvalgsregler.
            </p>

            <h3>8.2 Tvisteløsning</h3>
            <p>
              Eventuelle tvister som oppstår i forbindelse med disse Vilkårene skal først forsøkes løst gjennom forhandlinger. 
              Hvis forhandlinger ikke fører frem, skal tvisten løses ved norske domstoler med jurisdiksjon som verneting.
            </p>

            <h3>8.3 Hele avtalen</h3>
            <p>
              Disse Vilkårene utgjør hele avtalen mellom deg og oss angående Appen og erstatter alle tidligere avtaler mellom deg 
              og oss vedrørende Appen.
            </p>

            <h3>8.4 Kontaktinformasjon</h3>
            <p>
              Hvis du har spørsmål om disse Vilkårene, kan du kontakte oss på:
            </p>
            <ul>
              <li>E-post: <a href="mailto:support@lopeglad.no">support@lopeglad.no</a></li>
            </ul>
            <p className="last-updated">Sist oppdatert: 02.05.2025</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Vilkår;

